import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFPic from '@/components/UI/EFPic';

export default function E(): JSX.Element {
    const { useLang, useEffect } = useGlobal();
    const { t } = useLang('csr');

    useEffect(() => {
        const ScrollMagic = (window as any).ScrollMagic;
        
        const scene = new ScrollMagic.Scene({
            triggerElement: '.csr_pc_G',
            triggerHook: 1,
            offset: 300,
        }).setClassToggle('.csrGbox', 'show');
    
        new ScrollMagic.Controller().addScene(scene);
    }, []);

    return (
        <div className={`csr_pc_G ${css.csr_pc_G}`}>
            <div className="csrGbox">
                <div className="gImg">
                    <EFPic src={['/img/csr/pc/g-mail.webp', '/img/csr/pc/g-mail.png']} />
                </div>
                <div>
                    <div className="csr_top_box">
                        <div className="secG_title">{t('secG_title')}</div>
                        <div className="secG_desc">{t('secG_desc')}</div>
                    </div>
                    <hr className="secG_hr" />
                    <div className="csr_bottom_box">
                        <a href={`mailto:${t('secG_mail')}`} className="secG_mail">{t('secG_mail')}</a>
                    </div>
                </div>
                <div className="csrArrowBox">
                    <EFPic src={['/img/csr/pc/g-1.webp', '/img/csr/pc/g-1.png']} className="csrArrow" />
                </div>
            </div>
        </div>
    );
}